import axios from "axios";
import { GetBanksResponse } from "./dto/Banks";

/** 銀行マスタ取得 */
export const getBanks = async (): Promise<GetBanksResponse> => {
  const res = await axios.get<GetBanksResponse>(`/api/banks`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};
